// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import type { IEnvironmentModel } from 'commons';

import pkg from '../../../../package.json';
export const environment: IEnvironmentModel = {
  e2e: false,
  production: false,
  version: `${pkg?.version ?? '0.0.0'} DEV (#1396 2026-11-05-01:00:56+0000)`,
  appInsights: {
    instrumentationKey: '381d5f7f-a028-4c80-9585-63c224288dc0',
  },
  baseUrl: 'https://dtis-admin-d.dev.dp.schaeffler',
  tenantId: '67416604-6509-4014-9859-45e709f53d3f',

  // SG_DTIS_WEBAPPLICATION_D
  // https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/4c2e2013-2188-4f1c-9401-088249a45b5f
  clientId: '4c2e2013-2188-4f1c-9401-088249a45b5f',
  appScope: ['api://4c2e2013-2188-4f1c-9401-088249a45b5f/ROL_USER'],

  // SG_DTIS_API_D
  // https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/f827c093-1b6b-420f-9f58-29463d22484f
  apiScope: ['api://f827c093-1b6b-420f-9f58-29463d22484f/access_as_user'],
  loginUrl: 'https://login.microsoftonline.com/',
  postLogoutRedirectUri: window.location.origin,
  redirectUri: window.location.origin,
};
